import React, {useEffect, useState} from 'react';
import useOutsideClick from "../../hooks/useOutsideClick";
import useQCompanies from "../../queries/useQCompanies";
import {ICompanyResource} from "../../resources/ICompany.resource";
import CompanyObserver from "../../mobx/company/CompanyObserver";
import {observer} from "mobx-react-lite";
import styles from './styles.module.scss';
import useQProfile from "../../queries/useQProfile";
import {EnumModules} from "../../resources/IProfile.resource";

const CheckIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M19.2573 7.22745C19.5502 7.52033 19.5503 7.9952 19.2574 8.28811L10.773 16.7734C10.6324 16.9141 10.4416 16.9931 10.2427 16.9931C10.0437 16.9931 9.85297 16.9141 9.71231 16.7735L5.46967 12.5308C5.17678 12.2379 5.17678 11.7631 5.46967 11.4702C5.76256 11.1773 6.23744 11.1773 6.53033 11.4702L10.2426 15.1824L18.1967 7.22751C18.4895 6.9346 18.9644 6.93458 19.2573 7.22745Z" fill="#1E1E1E"/>
        </svg>
    );
}

const CompanyInfo = () => {
    const [isOpen, setIsOpen] = useState(false);
    const {companies} = useQCompanies();
    const {profile} = useQProfile();

    const handleClose = () =>setIsOpen(false);
    const handleToggleOpen = () => setIsOpen((prev) => !prev);

    const ref= useOutsideClick(handleClose);

    useEffect(() => {
        if(!companies) return;
        const localCompanyId = localStorage.getItem('company');

        if(localCompanyId) {
            CompanyObserver.setCompanyId(Number(localCompanyId));
        } else {
            const firstCompanyInList = companies.companies[0].id
            localStorage.setItem('company', String(firstCompanyInList));
            CompanyObserver.setCompanyId(Number(firstCompanyInList));
        }

    },[companies])

    const getSelectedCompanyById = (selectedCompanyId: number) => {
        if(!companies) return;
        return companies.companies?.find((item) => item.id === selectedCompanyId)?.name[0]
    };

    const handleSelectCompany = (companyId: number) => {
        localStorage.setItem('company', String(companyId));
        CompanyObserver.setCompanyId(Number(companyId));
        handleClose(); // Close dropdown on selection
    }

    if(profile?.modules.includes(EnumModules.LEAD_GENERATION)){
        return <></>;
    }

    return (
        <div
            ref={ref}
            className={styles.company}
        >
            <button
                type={'button'}
                className={styles.company__btn}
                onClick={handleToggleOpen}
            >
                {getSelectedCompanyById(Number(CompanyObserver.getCompanyId()))}
            </button>
            {isOpen ? (
                <div className={styles.company__list}>
                    {companies?.companies.map((item:ICompanyResource) => (
                        <button
                            key={item.id}
                            className={`${styles.company__item} ${CompanyObserver?.companyId === item.id ? styles.company__item_active : ''}`}
                            type={'button'}
                            onClick={() => handleSelectCompany(item.id)}
                            id={String(item.id)}
                        >
                            <div className={styles.company__fullname}>
                                <div className={styles.company__avatar}>
                                    {item.name[0]}
                                </div>
                                {item.name}
                            </div>
                            {CompanyObserver?.companyId === item.id ? <CheckIcon /> : null}
                        </button>
                    ))}
                </div>
            ) : null}
        </div>
    );
};

export default observer(CompanyInfo);
